import { render, staticRenderFns } from "./CategoryMedOld.vue?vue&type=template&id=45a7b36c"
import script from "./CategoryMedOld.vue?vue&type=script&lang=js"
export * from "./CategoryMedOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports